import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Redirect, Route } from 'react-router-dom';
const PrivateRoute = (routerProps) => (_jsx(Route, Object.assign({}, routerProps, { component: undefined, render: (renderProps) => {
        if (!localStorage.getItem('token')) {
            const { history: { location: { pathname, search } } } = renderProps;
            const redirect = pathname === '/' || pathname === '' ? null : pathname + search;
            return (_jsx(Redirect, { to: {
                    pathname: '/user/login',
                    state: { redirect },
                } }));
        }
        if (routerProps.component) {
            return _jsx(routerProps.component, Object.assign({}, renderProps));
        }
        return null;
    } })));
export default PrivateRoute;
